module.exports = __webpack_public_path__ + "img/image (33).bfe4b25e.jpg";